import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";
type Entity = models.ViajeRutaDto;
export interface Props {
    value: Entity[];
    onRefrescar?: () => void;
    HabilitarValidacionesCartaPorte : boolean;
}


/*
* Listado de StatusCajaRutaViewDto
*/
class ViajeRutaViewDtoListNoRx extends React.PureComponent<Props> {
    onCancelarViaje = async (x: models.ViajeRutaDto) => {
        if (await kea.yesno(`¿Cancelar viaje ${x.Folio} ?`)) {
            await resources.ViajeRuta.CancelarViaje(x.IdRegistro);
        }
    }

    onDarSalida = async (x: models.ViajeRutaDto) => {
        if (await kea.yesno(`¿Dar salida al viaje ${x.Folio} ?`)) {
            await resources.ViajeRuta.DarSalida(x.IdRegistro);
        }
    }

    onDarLlegada = async (x: models.ViajeRutaDto) => {
        if (await kea.yesno(`¿Dar llegada al viaje ${x.Folio} ?`)) {
            await resources.ViajeRuta.DarLlegada(x.IdRegistro);
        }
    }

    onImprimirManifiesto = async (x: Entity) => {
        if (await kea.yesno(`¿Imprimir manifiesto dell viaje ${x.Folio} ?`)) {
            //await kea.message("En desarrollo");
            var manifiesto = await resources.ViajeRuta.ReporteDeManifiesto(x.IdRegistro);
            kea.printPdf(manifiesto);
        }
    }

    onTimbrarCartaPorte = async (x: Entity) => {
        if (await kea.yesno(`¿timbrar carta por del viaje ${x.Folio} ?`)) {

            var xml = await resources.Factura.TimbrarCartaPorteViajeRuta(x.IdRegistro);
            kea.download(kea.base64ToBlob(xml, 'application/xml'), "CartaPorteViaje"+ x.Folio + ".xml");
            if  (!x.TieneXmlCartaPorteTimbrado)
            location.reload();
        }
    }

    onImprimirCartaPorte = async (x: Entity) => {
        if (await kea.yesno(`¿Imprimir pdf de carta porte del viaje ${x.Folio} ?`)) {
            var PdfCartaPorte = await resources.Factura.ImprimirPdfViajeRuta(x.IdRegistro);
            
            kea.download(kea.base64ToBlob(PdfCartaPorte, 'application/pdf'), "CartaPorteViaje"+ x.Folio + ".pdf");
            
            if  (!x.TienexmlImpreso)
            location.reload();
        }
    }

    render() {

        const cols = columnas(this, this.props.HabilitarValidacionesCartaPorte);
        return (
            <div>
                <kea.Title size="h3" titulo="Viajes de ruta" onRefrescar={this.props.onRefrescar} />
                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}

/**Muestra un listado de los status de caja */
export const ViajeRutaViewDtoListMem = componentToRx(ViajeRutaViewDtoListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/list/listmem.tsx